import type { GetLockboxesForListingResponse, JsonObject } from '@/app-package';
import axios from 'axios';

export type ListingMasterlocks = JsonObject<GetLockboxesForListingResponse>;

const getListingMasterlocks = async (listingId: string) => {
  const { data } = await axios.get<ListingMasterlocks>(
    `/lockbox/masterlock/listing/${listingId}`,
  );

  return data;
};

export default getListingMasterlocks;
